import { createAction } from 'typesafe-actions';

export const PDP_PRODUCT_REVIEWS_IN_VIEWPORT = createAction('ui/PDP_PRODUCT_REVIEWS_IN_VIEWPORT')();

export const PDP_REVIEWS_ADD_NEW_CLICK = createAction('ui/PDP_REVIEWS_ADD_NEW_CLICK')();
